// 弹框叠加时的层级栈。
//
// 为什么需要它：ModalShell 每个实例都在 document 上挂了一个 keydown 监听。弹框叠起来时
// （例如「办公日历」弹框上再弹新建表单 / 单据详情），按一次 Esc 会触发所有监听，
// 两层甚至三层一起关掉；Tab 焦点陷阱也会被下层抢回去。
// 这里记录当前打开的顺序，只让最上面那一层响应 Esc 与 Tab。
//
// 注意：必须放在模块作用域 —— 写在 <script setup> 里会变成"每个弹框一份"，等于没限制。
const stack: symbol[] = [];

export function pushModal(token: symbol) {
  if (!stack.includes(token)) stack.push(token);
}

export function popModal(token: symbol) {
  const at = stack.indexOf(token);
  if (at >= 0) stack.splice(at, 1);
}

export function isTopModal(token: symbol) {
  return stack[stack.length - 1] === token;
}

export function modalDepth() {
  return stack.length;
}

/**
 * 叠加弹框的层级：基线和全局 .ro-overlay 一样是 50，每深一层 +2。
 * 千万不要往上抬到几百：下拉菜单(.ro-select__menu 240)、文件选择器(75)、toast(100)
 * 都在这个区间之上，弹框一旦抬太高，Select 下拉和"从文件库选择"就会被自己的弹框盖住
 * （实测踩过：确认弹框被挡在发放预览弹框下面，点不到"发放"）。
 */
export function modalZIndex(depth: number) {
  return 50 + Math.max(0, depth) * 2;
}
